import { withErrorBoundary } from "@client/components/utils/ErrorBoundary";
import userIsAdmin from "@client/utils/userIsAdmin";
import { useContext } from "react";
import { Redirect } from "wouter";
import { StateContext } from "../round/Round";
import { ProposalFormPage } from "../round/settings/ProposalsForm";

const ProposalForms = withErrorBoundary(() => {
  const context = useContext(StateContext);
  const { round, actingAsUserId: userId } = context;

  const isAdmin = userIsAdmin(userId, context);
  if (!isAdmin) {
    return <Redirect to="/" />;
  }

  return (
    <div className="w-full h-full flex flex-col overflow-hidden">
      <h1 className="text-2xl font-bold p-4 pb-2">
        {round.name} Proposal Forms
      </h1>
      <div className="flex-1 overflow-y-auto p-4 pt-0">
        <ProposalFormPage />
      </div>
    </div>
  );
});

export default ProposalForms;
